// Words the board writes into the chat's box for the user to send (an empty widget's "Ask your agent", a sheet's or a
// deck's first ask). What the request says is the board's own, from the kind of thing; a name someone typed (a
// widget's title, which a coworker on a shared board can write) goes in only as a name: in quotes, on one line, short,
// and with no quote marks of its own to close the quotes and read on as words of the request (Fixes 8).

/** A name, as it goes inside the board's quotes: one line, no quote marks, at most 60 characters. Null when empty. */
export function askName(name: string | null | undefined): string | null {
  const one = String(name ?? "")
    .replace(/[\u0000-\u001f\u007f\u2028\u2029]+/g, " ")
    .replace(/["'`\u2018\u2019\u201a\u201b\u201c\u201d\u201e\u201f\u2039\u203a\u00ab\u00bb\u300c\u300d\u300e\u300f]+/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (!one) return null;
  if (one.length <= 60) return one;
  const cut = one.slice(0, 59);
  return `${(cut.replace(/\s+\S*$/, "") || cut).trimEnd()}…`;
}

/** An empty widget's ask: the board's own words from its kind, naming the widget in quotes when it has a name. */
export function fillAsk(kind: string | null | undefined, title: string | null | undefined): string {
  const name = askName(title);
  const what = kind?.trim() ? `${kind.trim()} widget` : "widget";
  return name ? `Connect the ${what} named “${name}” to live data` : `Connect this ${what} to live data`;
}
